import { render, staticRenderFns } from "./doc-view.vue?vue&type=template&id=8a07f326&scoped=true"
import script from "./doc-view.vue?vue&type=script&lang=js"
export * from "./doc-view.vue?vue&type=script&lang=js"
import style0 from "./doc-view.vue?vue&type=style&index=0&id=8a07f326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a07f326",
  null
  
)

export default component.exports